<h1 class="main sticky-top">
    <div class="row">
        <div class="col-sm-4">
            In Compliance Report
        </div>
        <div class="col-sm-8 text-md-end ">
            <button [disabled]="!isItemPacketSelected" type="button" class="btn btn-primary align-button"
                (click)="downloadReport()"><i class="fas fa-download" title="Download Report"></i> Export as CSV
            </button>
            <a uiSref="print.reports.volunteer.in-compliance" [uiParams]="{ 
                        itemPacket: this.request.ItemPacketId,
                        volunteerAreas: this.pagingHelperService.toArrayParam(this.request.VolunteerAreaIds) ?? [],
                        searchBy: this.request.SearchBy,
                        offset: this.request.Offset,
                        limit: this.request.Limit,
                        orderBy: this.request.OrderBy,
                        ascending: this.request.Ascending,
                        getAllResults: true
                    }" target="_blank" class="btn btn-info align-button ms-2" title="Print Report">
                <i class="fas fa-print" aria-hidden="true"></i>
            </a>
        </div>
    </div>
</h1>

<div class="col-sm-12 pb-2 border-bottom table-filter">
    <form [formGroup]="form" (submit)="search(form)" class="d-flex flex-row align-items-center flex-wrap">
        <edl-floating-label-container label="Item Packet" for="itemPacketSelect"   class="w-auto mt-2 mb-2 me-sm-2 mb-sm-0" style="max-width: 300px;">
            <select id="itemPacketSelect" class="form-select" formControlName="itemPacket" (change)="search(form)">
                <option disabled [ngValue]="null">Select</option>
                <option *ngFor="let packet of itemPackets" [value]="packet.Id">
                    <!-- <item-packet-pill [pill]="packet.Pill" [showTitle]="false"></item-packet-pill> -->
                    {{packet.Pill.Title.length > 50 ? packet.Pill.Title.substring(0, 47) + '...' : packet.Pill.Title | slice:0:40 }}
                </option>
            </select>
        </edl-floating-label-container>

        <edl-floating-label-container label="Volunteer Areas" for="volunteerAreasEntriesForm" class="w-auto mt-2 me-2">
            <edl-entries-form
                id="volunteerAreasEntriesForm"
                [formGroup]="volunteerAreasForm"
                [inlineAddButton]="true"
                (inlineAddItem)="filterGroups(volunteerAreasForm, EDLGroupType.VOLUNTEER_AREA)">
            </edl-entries-form>
        </edl-floating-label-container>

        <edl-floating-label-container label="Search" for="searchByInCompliance" class="w-auto mt-2 me-2">
            <div class="input-group" (change)="search(form)">
                <input id="searchByInCompliance" type="text" class="form-control" formControlName="searchBy" />
                <button type="submit" class="input-group-text btn btn-info" aria-label="Search"><i class="fas fa-search" aria-hidden="true"></i></button>
            </div>
        </edl-floating-label-container>

        <button type="button" class="w-auto btn btn-primary input-group mt-2 me-2" (click)="search(form)">
            <i class="fas fa-sync"></i> Refresh
        </button>
    </form>
</div>

<pagination-loading-overlay [isLoading]="isLoading" [currentPage]="currentPage">
    <div class="overflow-box">
        <div *ngIf="!isItemPacketSelected" class="alert alert-info">
            <p>Please select an item packet to view or print the report.</p>
        </div>

        <table *ngIf="isItemPacketSelected" class="table d-none d-lg-block outer-table">
            <caption class="visually-hidden">In compliance report showing name, item packets, and volunteer areas</caption>
            <thead>
                <tr>
                    <th scope="col" class="fit no-wrap">Name</th>
                    <th scope="col" class="no-wrap">Item Packets</th>
                    <!-- <th scope="col" class="no-wrap">In Compliance Until</th> -->
                    <th scope="col" class="no-wrap">Volunteer Areas</th>
                </tr>
            </thead>
            <tbody *ngFor="let entry of pagedResponse?.Results">
                <tr>
                    <td>{{entry.Name}} <br /> <span style="font-size: 1em;">{{entry.Email}}</span></td>
                    <td>
                        <item-packet-pill [pill]="getItemPacket(entry.ItemPacketId).Pill" [showStatusStamp]="true"
                            [status]="getInComplianceStatus(entry.IsInCompliance)"></item-packet-pill>
                        <!-- <span *ngIf="entry.IsExpiringSoon" class="ms-2 badge bg-warning">Expiring Soon</span> -->
                    </td>
                    <!-- <td>
                        <span class='action-required'
                            *ngIf="DateHelpers.isMinDate(DateHelpers.shortDateStringToDate(DateHelpers.DateToShortDate(entry.EndDate)))">No
                            Expiration Date</span>
                        <span
                            *ngIf="DateHelpers.shortDateStringToDate(DateHelpers.DateToShortDate(entry.EndDate)) === DateHelpers.shortDateStringToDate('9999-01-01')">No
                            Expiration Date</span>
                        <span
                            *ngIf="!DateHelpers.isMinDate(DateHelpers.shortDateStringToDate(DateHelpers.DateToShortDate(entry.EndDate)))">
                            {{ entry.EndDate | date: 'MM/dd/yyyy' }}
                        </span>
                    </td> -->
                    <td>{{entry.VolunteerAreas}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</pagination-loading-overlay>

<div class="content">
    <div class="row">
        <div class="col-sm-12 text-end">
            <edl-pagination *ngIf="pagedResponse?.TotalNumberPages > 1"
                [collectionSize]="pagedResponse?.TotalCount"
                [(page)]="currentPage"
                [pageSize]="pagedResponse?.Limit"
                (pageChange)="onPageChange($event)"></edl-pagination>
        </div>
    </div>
</div>